module.exports = {

    roundPrecision: (number, decimals = 2) => {
        return Math.round(number * Math.pow(10, decimals)) / Math.pow(10, decimals);
    },

    format: (number, decimals = 2, point = '.') => {
        let result = ('' + module.exports.roundPrecision(number % 1, decimals));
        result = result > Math.pow(10, -decimals) / 2 ? point + result.substr(2) : '';

        let str = '' + Math.floor(number);
        for (let i = str.length; i >= 0; i -= 3) {
            result = ' ' + str.substring(i - 3, i) + result;
        }

        result = result.trim();

        return result;
    }

};